import axios from 'axios'

const store = {
  namespaced: true,

  state: {
    profile: null,
  },
  getters: {
    profile: state => state.profile,
  },
  mutations: {
    SET_STATE (state, { key, value }) {
      state[key] = value
    },
    PUSH_STATE (state, {key, value }) {
      state[key].push(value)
    },
  },
  actions: {
    // eslint-disable-next-line
    async updatePassword ({}, form) {
      await axios.post('/profile/password', form)
    },

    async getProfile ({ commit }) {
      const response = await axios.get('/profile')

      commit('SET_STATE', { key: 'profile', value: response.data.data })
    },

    async updateProfile ({ commit }, form) {
      const response = await axios.post('/profile', form)

      commit('SET_STATE', { key: 'profile', value: response.data.data })
    },
  },
}

export default store
